import Modal from 'react-modal';
import { FaSpinner } from 'react-icons/fa';
import { MaskedInput } from 'src/presentation/components';

import styles from '../../../pages/submission/submission.module.scss';

interface SmsVerificationModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    smsCode: string;
    setSmsCode: (code: string) => void;
    isSendingSms: boolean;
    onVerify: () => void;
    onResend: () => void;
    canResend: boolean;
    resendTimer: number;
    phone: string;
    isVerifyingSms: boolean;
    smsError: string;
    setSmsError: (error: string) => void;
}

export const SmsVerificationModal: React.FC<SmsVerificationModalProps> = ({
    isOpen,
    onRequestClose,
    smsCode,
    setSmsCode,
    isSendingSms,
    onVerify,
    onResend,
    canResend,
    resendTimer,
    phone,
    isVerifyingSms,
    smsError,
    setSmsError
}) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className={styles.modal}
        overlayClassName={styles.modalOverlay}
        ariaHideApp={false}
    >
        <div className={styles.modalContent}>
            <h3>Estamos quase lá!</h3>
            <p>Antes de finalizar o cadastro, insira o código de 6 dígitos enviado para o número {phone}</p>
            <MaskedInput
                value={smsCode}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSmsCode(e.target.value);
                    setSmsError('');
                }}
                id="smsCode"
                name="smsCode"
                mask="999999"
                label="Código de verificação"
                loading={isSendingSms}
                disabled={isVerifyingSms}
            />
            {smsError && (
                <span className={styles.inputErrorText} role="alert">{smsError}</span>
            )}
            <div className={styles.modalActions}>
                <button
                    type="button"
                    className={styles.backBtn}
                    onClick={onRequestClose}
                    disabled={isVerifyingSms}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className={`${styles.nextBtn} ${isVerifyingSms ? styles.loadingButton : ''}`}
                    onClick={onVerify}
                    disabled={smsCode.length !== 6 || isSendingSms || isVerifyingSms}
                >
                    {isVerifyingSms ? (
                        <>
                            <FaSpinner className={styles.spinner} style={{ marginRight: 8 }} />
                            Verificando...
                        </>
                    ) : 'Verificar'}
                </button>
                <button
                    type="button"
                    className={styles.resendBtn}
                    onClick={onResend}
                    disabled={!canResend || isVerifyingSms}
                    style={{ marginLeft: 8 }}
                >
                    {canResend ? 'Reenviar código' : `Reenviar em ${resendTimer}s`}
                </button>
            </div>
        </div>
    </Modal>
);